import { BCMSDate } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";

/**
@function CopyrighView
@returns {React.Component}
@description A component for the Beavercreek Marketing copyright disclaimer shown throughout the module. 
@example 
    const copyrightView = <CopyrightView/>;
**/
export default function CopyrightView(props) {
    const copyrightYear = BCMSDate.init().format("Y");

    return (
        <div className="copyright-container">
            <span className="copyright-label">{ `Copyright ©${ copyrightYear } Beavercreek Marketing. All Rights Reserved.` }</span>
        </div>
    );
}